// The Inventory destination: Purchasing, Stock, and Supply & Demand.
// Everything about one material opens from clicking the item, not as a tab of its own.

import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useCrumb } from '../../frame/Frame';
import { Head, Seg } from '../../ui/kit';
import { MaterialPanel } from './MaterialPanel';
import { Purchasing } from './Purchasing';
import { Stock } from './Stock';
import { SupplyDemand } from './SupplyDemand';
import { useInventoryNames } from './names';

type Tab = 'purchasing' | 'stock' | 'supply';

export function Inventory() {
  const names = useInventoryNames();
  const [params, setParams] = useSearchParams();
  const [materialId, setMaterialId] = useState<string | null>(params.get('material'));
  const tab = (params.get('tab') as Tab) || 'purchasing';
  useCrumb([{ label: names.rail }]);

  return (
    <div>
      <Head title={names.rail}>
        <Seg
          items={[
            { key: 'purchasing', label: names.purchasing },
            { key: 'stock', label: names.stock },
            { key: 'supply', label: names.supply_demand },
          ]}
          value={tab}
          onChange={(k) => setParams({ tab: k }, { replace: true })}
        />
      </Head>
      {tab === 'purchasing' && <Purchasing openMaterial={setMaterialId} />}
      {tab === 'stock' && <Stock openMaterial={setMaterialId} />}
      {tab === 'supply' && <SupplyDemand openMaterial={setMaterialId} />}
      {materialId && <MaterialPanel materialId={materialId} onClose={() => setMaterialId(null)} />}
    </div>
  );
}
